import React from 'react';
import { PropTypes } from 'prop-types';
import { Field } from 'redux-form';

/* eslint-disable react/no-array-index-key */
export const BoxInput = ({
  name,
  component,
  boxLength,
  cellWidth,
  cellHeight,
  strokeColor,
  fillColor,
  strokeWidth,
  letterSpacing,
  mask,
  placeholder,
  svgTemplate,
  normalize,
  className
}) => (
  <div className="box-input-group">
    <Field
      name={ name }
      component={ component }
      placeholder={ placeholder }
      mask={ mask }
      normalize={ normalize }
      className={ `overflowed ${ className }` }
      style={ {
        height: cellHeight,
        width: `calc(100% + ${ letterSpacing }px + 2px`,
        letterSpacing: `${ letterSpacing }px`
      } }
    />
    { svgTemplate || <svg
      width={ boxLength * (cellWidth + 1) }
      height={ cellHeight + 2 }
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      { Array(boxLength).fill(0).map((el, index) => (
        <rect
          x={ (index * cellWidth) + 1 }
          y="1"
          width={ cellWidth }
          height={ cellHeight }
          stroke={ strokeColor }
          fill={ fillColor }
          strokeWidth={ strokeWidth }
          key={ `box-input-cell-${ index }` }
        />
      )) }
    </svg> }
  </div>
);
/* eslint-enable react/no-array-index-key */

BoxInput.propTypes = {
  name: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  boxLength: PropTypes.number.isRequired,
  cellWidth: PropTypes.number,
  cellHeight: PropTypes.number,
  strokeColor: PropTypes.string,
  fillColor: PropTypes.string,
  strokeWidth: PropTypes.number,
  letterSpacing: PropTypes.number,
  mask: PropTypes.string,
  placeholder: PropTypes.string,
  svgTemplate: PropTypes.node,
  normalize: PropTypes.func,
  className: PropTypes.string
};

BoxInput.defaultProps = {
  component: 'input',
  cellWidth: 32,
  cellHeight: 32,
  strokeColor: '#000',
  fillColor: '#dbe4fd',
  strokeWidth: 1,
  letterSpacing: 19,
  mask: null,
  placeholder: '',
  svgTemplate: null,
  normalize: null,
  className: ''
};

export * from './BoxInputDotDivider';
